// extracted by css-extract-rspack-plugin
export default {"horizontalButton":"UgFcU","nested":"_MEhK","ClickActionButtonIcon":"SDPOp","inner":"pMUGl","label":"vbRlx"};